import script from "./NavbarDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarDropdown.vue?vue&type=script&setup=true&lang=js"

import "./NavbarDropdown.vue?vue&type=style&index=0&id=6318d9c4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6318d9c4"]])

export default __exports__